import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IconBoxEventButtonComponent } from "../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";

import PropTypes from "prop-types";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { get_all_order_vendor_side } from "../../../../store/actions/OrderingAction/vendorOrderingAction";

class TopMenuLeft extends Component {
  pageDirectClickHandler = (actionPage, id) => (e) => {
    if (actionPage === "pendingPage") {
      this.props.history.push({
        pathname: `/offline-events-pending/${id}`,
        state: { offlineEventInformation: id, actionBy: actionPage },
      });
    } else if (actionPage === "rsvpPage") {
      this.props.history.push({
        pathname: `/offline-events-details/${id}`,
        state: { offlineEventInformation: id, actionBy: actionPage },
      });
    } else if (actionPage === "ticketPage") {
      this.props.history.push({
        pathname: `/offline-events-booked/${id}`,
        state: { offlineEventInformation: id, actionBy: actionPage },
      });
    } else if (actionPage === "historyPage") {
      this.props.history.push({
        pathname: `/offline-events-history/${id}`,
        state: { offlineEventInformation: id, actionBy: actionPage },
      });
    } else {
      this.props.history.push({
        pathname: `/offline-events-all/${id}`,
        state: { offlineEventInformation: id, actionBy: actionPage },
      });
    }
  };

  render() {
    const { pathname } = this.props;
    const pendingWhite = require("../../../../assets/images/seatingImages/emailWhite.png");
    const pendingDark = require("../../../../assets/images/seatingImages/emailBlack.png");
    const seatingWhite = require("../../../../assets/images/seatingImages/happy-new-yearwhite.svg");
    const seatingDark = require("../../../../assets/images/seatingImages/happy-new-year.svg");
    const reservationWhite = require("../../../../assets/images/seatingImages/movie-seat-white.svg");
    const reservationDark = require("../../../../assets/images/seatingImages/movie-seat.svg");
    const historyWhite = require("../../../../assets/images/seatingImages/historyWhite.png");
    const historyDark = require("../../../../assets/images/seatingImages/historyBlack.png");
    const allDark = require("../../../../assets/images/Events/Group 53611.svg");
    const allWhite = require("../../../../assets/images/Events/indent-all.svg");

    return (
      <React.Fragment>
        <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 seating-left-side-navigation p-0 pt-3">
          <div className="row w-100">
            <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center">
              <IconBoxEventButtonComponent
                classSection={
                  this.props.selectedPage === 2
                    ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                    : "seating-dashboard-reusable-button"
                }
                imageStyle="inside-image-button"
                src={this.props.selectedPage === 2 ? pendingWhite : pendingDark}
                iconText="Pending"
                iconTextStyle={
                  this.props.selectedPage === 2
                    ? "icon-bottom-text icon-bottom-text-active"
                    : "icon-bottom-text"
                }
                // link={
                //   pathname.includes("superadmin")
                //     ? "/superadmin-offline-events-pending"
                //     : "/offline-events-pending"
                // }
                onClick={this.pageDirectClickHandler(
                  "pendingPage",
                  this.props.dataProps._id
                )}
                bedgeClass="badge custom-icon-button-badge-rsvp custom-badge-position-rsvp-pending cutom-badge-rsvp-bgorange"
                displayNotification={true}
                notificationCount={this.props.totalCountPending}
                bottomLine={
                  this.props.selectedPage === 2 ? "bottom-box-line" : null
                }
              />
            </div>
            <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center">
              <IconBoxEventButtonComponent
                classSection={
                  this.props.selectedPage === 1
                    ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                    : "seating-dashboard-reusable-button"
                }
                imageStyle="inside-image-button-seat w-100"
                src={this.props.selectedPage === 1 ? seatingWhite : seatingDark}
                iconText="RSVP"
                iconTextStyle={
                  this.props.selectedPage === 1
                    ? "icon-bottom-text icon-bottom-text-active"
                    : "icon-bottom-text"
                }
                // link={
                //   pathname.includes("superadmin")
                //     ? "/superadmin-offline-events-details"
                //     : "/offline-events-details"
                // }
                onClick={this.pageDirectClickHandler(
                  "rsvpPage",
                  this.props.dataProps._id
                )}
                bedgeClass="badge custom-icon-button-badge-rsvp custom-badge-position-rsvp cutom-badge-rsvp-bgdarkgreen"
                displayNotification={true}
                notificationCount={this.props.totalCountRsvp}
                bottomLine={
                  this.props.selectedPage === 1 ? "bottom-box-line" : null
                }
              />
            </div>
            {this.props.dataProps.ticket_booking_subscription ? (
              <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center">
                <IconBoxEventButtonComponent
                  classSection={
                    this.props.selectedPage === 3
                      ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                      : "seating-dashboard-reusable-button"
                  }
                  imageStyle="inside-image-button"
                  src={
                    this.props.selectedPage === 3
                      ? reservationWhite
                      : reservationDark
                  }
                  iconText="Ticket Booked"
                  iconTextStyle={
                    this.props.selectedPage === 3
                      ? "icon-bottom-text icon-bottom-text-active"
                      : "icon-bottom-text"
                  }
                  // link={
                  //   pathname.includes("superadmin")
                  //     ? "/superadmin-offline-events-booked"
                  //     : "/offline-events-booked"
                  // }
                  onClick={this.pageDirectClickHandler(
                    "ticketPage",
                    this.props.dataProps._id
                  )}
                  bedgeClass="badge custom-icon-button-badge-rsvp custom-badge-position-rsvp-ticket cutom-badge-rsvp-bglightgreen"
                  displayNotification={true}
                  notificationCount={this.props.totalCountTicket}
                  bottomLine={
                    this.props.selectedPage === 3 ? "bottom-box-line" : null
                  }
                />
              </div>
            ) : null}
            <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center">
              <IconBoxEventButtonComponent
                classSection={
                  this.props.selectedPage === 4
                    ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                    : "seating-dashboard-reusable-button"
                }
                imageStyle="inside-image-button"
                src={this.props.selectedPage === 4 ? historyWhite : historyDark}
                iconText="History"
                iconTextStyle={
                  this.props.selectedPage === 4
                    ? "icon-bottom-text icon-bottom-text-active"
                    : "icon-bottom-text"
                }
                // link={
                //   pathname.includes("superadmin")
                //     ? "/superadmin-offline-events-history"
                //     : "/offline-events-history"
                // }
                onClick={this.pageDirectClickHandler(
                  "historyPage",
                  this.props.dataProps._id
                )}
                bottomLine={
                  this.props.selectedPage === 4 ? "bottom-box-line" : null
                }
              />
            </div>
            <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center">
              <IconBoxEventButtonComponent
                classSection={
                  this.props.selectedPage === 5
                    ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                    : "seating-dashboard-reusable-button"
                }
                imageStyle="inside-image-button"
                src={this.props.selectedPage === 5 ? allWhite : allDark}
                iconText="All"
                iconTextStyle={
                  this.props.selectedPage === 5
                    ? "icon-bottom-text icon-bottom-text-active"
                    : "icon-bottom-text"
                }
                // link={
                //   pathname.includes("superadmin")
                //     ? "/superadmin-offline-events-all"
                //     : "/offline-events-all"
                // }
                onClick={this.pageDirectClickHandler(
                  "allPage",
                  this.props.dataProps._id
                )}
                bottomLine={
                  this.props.selectedPage === 5 ? "bottom-box-line" : null
                }
              />
            </div>
          </div>
          <div className="col-12 p-0">
            <hr className="mobile-device-line" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// TopMenuLeft.propTypes = {
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
// };

export default withRouter(TopMenuLeft);
